import * as React from 'react'
import { Monitor, Moon, Sun } from 'lucide-react'
import type { Theme } from '@/state/theme-context'
import { useTheme } from '@/state/theme-context'
import { Button } from '@/components/ui/button'

const choices = [
  { value: 'system', label: 'System', icon: Monitor },
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
] as const

export function ThemeIcon({ theme }: { theme: Theme }) {
  const Icon = choices.find((choice) => choice.value === theme)!.icon
  return <Icon aria-hidden="true" />
}

export const ThemeCycleButton = React.forwardRef<HTMLButtonElement, { iconOnly?: boolean; className?: string }>(function ThemeCycleButton({ iconOnly = false, className }, ref) {
  const { theme, setTheme } = useTheme()
  const index = choices.findIndex((choice) => choice.value === theme)
  const label = choices[index].label
  return <Button
    ref={ref}
    type="button"
    variant="ghost"
    size={iconOnly ? 'icon' : 'default'}
    className={className}
    aria-label={`Theme: ${label}`}
    title={iconOnly ? `Theme: ${label}` : undefined}
    onClick={() => setTheme(choices[(index + 1) % choices.length].value)}
  >
    <ThemeIcon theme={theme} />
    {!iconOnly && <span>Theme: {label}</span>}
  </Button>
})
